import { gql } from "@apollo/client";

export const GET_DASHBOARD_SNAPSHOT = gql`
  query GetDashboardSnapshot($year: String!) {
    dashboardSnapshot(year: $year) {
      experienceSummary
      generatedAtUtc
      recommendedFocusArea
      groupSnapshot {
        activeGuarantorsCount
        activeLoansCount
        activeMembersCount
        amountDueThisMonth
        collectedContributionSoFar
        collectedContributionToDate
        collectionRatePercent
        collectionRateToDatePercent
        contributionOutstandingToDate
        currentCashBalance
        expectedContributionForYear
        expectedContributionToDate
        groupId
        healthSummary
        isContributionUpToDate
        loanApplicationsInPipelineCount
        membersBehindOnContributionsCount
        membersFullyUpToDateCount
        membersWithSchedulesCount
        overdueContributionAmount
        overdueLoanAmount
        pendingContributionAmount
        pendingTransactionsAmount
        pendingTransactionsCount
        portfolioAtRiskPercent
        priorityAction
        totalGuaranteeExposure
        totalLoanBookOutstanding
        totalLoansPaidBack
        totalFinesPaid
        totalLoanPrincipalDisbursedThisYear
        year
      }
      memberSnapshot {
        availableContributionAfterLiabilities
        contributionOutstandingToDate
        contributionPaidToDate
        expectedContributionToDate
        expectedTotalContributionForYear
        groupId
        isContributionUpToDate
        loansGuaranteedCount
        loansTakenCount
        totalContributionSoFar
        totalGuarantorshipAmount
        totalLoanPrincipalTaken
        totalLoansPaid
        totalLoansPending
        userId
        year
      }
    }
  }
`;
